import React, { Component } from 'react';

const Action = ({ label, onClick, address, disabled = false }) => {
  return <a
    onClick={disabled ? e => (e.preventDefault()) : onClick }
    className={`text-capitalize text-primary btn btn-link text-nowrap ${disabled ? 'text-gray-lighten-2' : ''}`}>
    <u>{label}</u>
  </a>;
};

class Address extends Component {
  render() {
    const {
      first_name,
      last_name,
      company,
      street1 = '',
      street2 = '',
      street3 = '',
      street4 = '',
      city = '',
      state = '',
      postcode = '',
      country_name: country = '',
      telephone_number = '',
      is_default_shipping: isDefaultShipping = false,
      onEdit = () => {},
      onDelete = () => {},
      onMakeDefault = () => {},
      hide = false,
      disabled = false,
      t
    } = this.props;
    
    let streetStr = ['street1',
      'street2', 'street3', 'street4', 'city'].reduce((sum, k) => {
      const str = this.props[k] ? this.props[k] + ', ' : '';
      return sum + str;
    }, '');

    const showStateIfExist = state || '';
    const postcodeStr = postcode ? `${postcode} ` : '';
    let addressStr = `${postcodeStr}${showStateIfExist}, ${country}`;

    const textClass = disabled ? 'text-gray-lighten-2' : '';
    return (
      <div className={`col ${textClass}`}>
        <div className='ProximaNova-Bold'>{first_name + ' ' + last_name}</div>
          { company && <div>{company}</div> }
          {streetStr}
          <br/>{addressStr}
          <br/>{telephone_number}
        <div className='row'>
          {!hide &&
            <Action
              disabled={disabled}
              label={t("account.address_edit", "Edit")}
              onClick={onEdit}
              address={this.props}
            />
          }
          {!hide && <div className="text-primary pt-2">|</div>}
            <Action
              disabled={disabled}
              label={t("account.address_delete", "Delete")}
              onClick={onDelete}
              address={this.props}
            />
          { !isDefaultShipping && !hide &&
            <div className="text-primary pt-2">|</div>
          }
          { !isDefaultShipping && !hide &&
            <Action
              disabled={disabled}
              label={t("account.address_default", "Make default")}
              onClick={onMakeDefault}
              address={this.props}
            />
          }
        </div>
      </div>
    );
  }
}

export default Address;



// WEBPACK FOOTER //
// ./src/Address/Address.js